import type {
  AuthData,
  ThirdPartyLogin,
  ThirdPartyPhoneVerifyCopy,
  ThirdPartyRegister,
  ThirdPartySMS,
  ThirdPartyVerify
} from '@/models/interface/auth';
import { ApiFactory, type ApiDataResponse, type ApiResponse } from '@/utils/api';

export class AuthService extends ApiFactory {
  constructor() {
    super('Auth');
  }

  /** Google驗證 */
  googleVerify(idToken: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`GoogleVerify`, { idToken });
  }

  /** Meta驗證 */
  metaVerify(accessToken: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`FacebookVerify`, { accessToken });
  }

  /**
   * Line驗證
   * @param token
   * @param isIdToken accessToken false, idToken true
   * @returns
   */
  lineVerify(token: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`LineVerify`, {
      token,
      isIdToken: false
    });
  }

  /**
   * Apple驗證
   * @param token
   * @param isIdToken accessToken false, idToken true
   * @returns
   */
  appleVerify(token: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`AppleVerify`, {
      token,
      isIdToken: false
    });
  }

  thirdPartySMSVerification(data: ThirdPartySMS): Promise<ApiDataResponse<string>> {
    return super.post(`ThirdPartySMSVerification`, data);
  }

  thirdPartyRegister(data: ThirdPartyRegister): Promise<ApiDataResponse<string>> {
    return super.post(`ThirdPartyRegister`, data);
  }

  /**
   * 新三方驗證註冊
   * @param data
   * @returns token
   */
  thirdPartyVerify(
    data: ThirdPartyVerify
  ): Promise<ApiDataResponse<{ token: string; actionType: number }>> {
    return super.post(`ThirdPartyVerify`, data);
  }

  /**
   * 三方驗證簡訊驗證碼
   * @param data
   * @returns
   */
  thirdPartyLogin(data: ThirdPartyLogin): Promise<ApiResponse> {
    return super.post(`ThirdPartySmsInfo`, data);
  }

  /**
   * 三方發送簡訊驗證碼
   * @param data 手機號碼
   * @returns 驗證碼
   */
  sendSmsVerify(data: { phone: string }): Promise<ApiDataResponse<string>> {
    return super.post(`SendSmsVerify`, data);
  }

  /**
   * 亂數取得三方手機驗證文案
   */
  getThirdPartyPhoneVerifyCopy(): Promise<ApiDataResponse<ThirdPartyPhoneVerifyCopy>> {
    return super.get('GetThirdPartyPhoneVerifyCopy');
  }
}
